import Vue from 'vue';
import plugin, { trackMutations } from './plugin';

// custom register stores to inject tracking
Vue.prototype.$storeRegister = function(
  name: string,
  store: (args: any) => any,
) {
  // allow only one store instance to survive
  if (this.$store.state[name]) {
    return;
  }

  this.$store.registerModule(
    name,
    store({
      trackMutations: trackMutations(name),
    }),
  );
};

Vue.prototype.$storeUnregister = function(name: string) {
  this.$store.unregisterModule(name);
};

export default plugin;

export {
  trackMutations,
};
